export type LinkedFacilityConfig = {
  facilityId: string;
  name: string;
  groupId: string;
  order?: number;
  isVisible?: boolean;
  redirectPath?: string;
};

const CONFIG: LinkedFacilityConfig[] = [
  {
    facilityId: "1257",
    name: "Pływalnia sportowa",
    groupId: "bosir-bialystok",
    order: 1,
    redirectPath: "/customOffer?offerId=plwalniasportowa",
  },
  {
    facilityId: "1258",
    name: "Pływalnia rodzinna",
    groupId: "bosir-bialystok",
    order: 2,
    redirectPath: "/customOffer?offerId=plywalniarodzinna",
  },
  {
    facilityId: "1252",
    name: "Lodowisko",
    groupId: "bosir-bialystok",
    order: 3,
    redirectPath: "/customOffer?offerId=lodowiskobosir",
  },
  {
    facilityId: "1250",
    name: "Padel Zawady",
    groupId: "bosir-bialystok",
    order: 4,
    redirectPath: "/customOffer?offerId=rezerwacje",
  },
];

export const linkedFacilitiesConfig = CONFIG;

export function getLinkedFacilitiesFor(currentId: string): LinkedFacilityConfig[] {
  const entry = CONFIG.find((item) => item.facilityId === currentId);

  if (!entry) {
    return [];
  }

  const groupId = entry.groupId;

  return CONFIG
    .filter((item) => item.groupId === groupId && item.isVisible !== false)
    .sort((a, b) => (a.order ?? 0) - (b.order ?? 0));
}

export function hasLinkedFacilities(currentId: string): boolean {
  return getLinkedFacilitiesFor(currentId).length > 1;
}

